import QPagination from './src/QPagination.vue';

QPagination.install = Vue => {
  Vue.component(QPagination.name, QPagination);
};

export default QPagination;
